import React from "react";
import { Box, Heading } from "@chakra-ui/react";
import { useCustomTheme } from "../../../contexts/CustomThemeContext";

type Props = {
  title: string;
  children: React.ReactNode;
  rightSlot?: React.ReactNode;
};

const FinanceSectionCard: React.FC<Props> = ({ title, children, rightSlot }) => {
  const { theme } = useCustomTheme();

  return (
    <Box
      bg={theme.surface}
      border={`1px solid ${theme.border}`}
      borderRadius="24px"
      boxShadow={theme.shadowMd}
      p={{ base: 4, md: 6 }}
    >
      <Box
        display="flex"
        alignItems={{ base: "stretch", md: "center" }}
        justifyContent="space-between"
        flexDirection={{ base: "column", md: "row" }}
        gap={3}
        mb={5}
      >
        <Heading size="md" color={theme.text}>
          {title}
        </Heading>
        {rightSlot}
      </Box>
      {children}
    </Box>
  );
};

export default FinanceSectionCard;
